import React, { useEffect } from 'react';
import Comment from '../utterances/Comments';

export const PostComments = ({ title, theme }) => {
  const commentBox = React.createRef();

  useEffect(() => {
    const script = document.getElementById('comments');
    if (script) {
      document.body.removeChild(script);
    }

    const scriptEl = document.createElement('script');
    scriptEl.async = true;
    scriptEl.id = 'utterances';
    scriptEl.src = 'https://utteranc.es/client.js';
    scriptEl.setAttribute('repo', 'anishkoulgi/Utterance-comments');
    scriptEl.setAttribute('issue-term', title);
    scriptEl.setAttribute('theme', theme);
    scriptEl.setAttribute('crossorigin', 'anonymous');
    if (commentBox && commentBox.current) {
      commentBox.current.appendChild(scriptEl);
    } else {
      console.log(`Error adding utterances comments on: ${commentBox}`);
    }

    return () => document.getElementsByClassName('utterances')[0]?.remove();
  }, [theme]);

  return (
    <div style={{ width: '100%', marginTop: '2rem' }}>
      <Comment commentBox={commentBox} />
    </div>
  );
};
